export default __webpack_public_path__ + "static/media/Book4.20f62966.webp";